import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import StaticFunctions from "../utils/StaticFunctions";


class ShiftSelector extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        onShiftSelected: PropTypes.func.isRequired,
    };

    static defaultProps = {
        currentShift: null,
        addAllOption: true,
    };

    constructor(props) {

        super(props);

        // Properties:
        // Shifts - utils/entities/shifts
        // onShiftSelected - callback, returns the shift-object
        // currentShift - Shift-Object - preset the selected shift

        this.state = {
            currentShiftId: props.currentShift ? props.currentShift.id : null
        };

        this.translate = this.props.baseData.translate;

        this.selectShift = this.selectShift.bind(this);

    }

    componentDidMount() {

        this.checkForValidSelection();

    }

    componentDidUpdate(prevProps, prevState) {

        this.checkForValidSelection();

    }

    // Shift auf - setzen, wenn nicht gefunden
    checkForValidSelection() {

        if (this.state.currentShiftId !== 0 && this.getShiftById(this.state.currentShiftId) === false) {
            this.setState({
                currentShiftId: 0
            });
        }

    }

    selectShift(s) {

        if (s) {
            let shift = this.getShiftById(s.value);

            if (String(this.state.currentShiftId) === String(shift.id)) return;

            this.setState({currentShiftId: shift.id});

            if (this.props.onShiftSelected) this.props.onShiftSelected(shift);
        }

    }

    getShiftById(id) {

        const opt = this.props.baseData.shifts ? this.props.baseData.shifts.getAllShifts() : [];

        for (let ix in opt) {
            let shift = opt[ix];

            if (String(shift.id) === String(id)) return shift;
        }

        return false;

    }

    getOptions() {

        const shifts = this.props.baseData.shifts ? this.props.baseData.shifts.get() : [];
        const sortedShifts = StaticFunctions.getSortedData(shifts, 'name', 'string');
        const opts = [];

        if (this.props.addAllOption)  {
            const nullShift = this.props.baseData.shifts.getNullShift();

            opts.push({value: String(nullShift.id), label: this.translate(nullShift.name)});
        }

        for (let ix in sortedShifts) {
            let shift = sortedShifts[ix];
            let label = (shift.name) ? shift.name : shift.id;

            opts.push({
                value: String(shift.id),
                label: label,
            })
        }

        return opts;

    }

    render() {
        const opts = this.getOptions();
        const selectedOption = opts.find(o => o.value === String(this.state.currentShiftId)) || null;

        return (
            <Select
                name="form-field-name"
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={opts}
                onChange={this.selectShift}
                value={selectedOption}
                clearable={false}
                placeholder={this.translate('select') + '...'}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default ShiftSelector;